module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-20-399e1ffd0a34b40bef31a87ff2d4cc09.png";